import React, { Component } from "react";
import { Table, Row, Container, Col, DropdownToggle, DropdownMenu, DropdownItem, Dropdown } from "reactstrap";

// UI Components
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

import { getMessage } from "CONFIG/i18n";

// Utilities
import {
  listOfAvailableModule,
  modulesAvailableConstant,
  BUSINESS_MODELS
} from "../../../Utils/Constants";
import { formatDateByLocale, getTimeInLocaleTimezone, convertMinutesToDDhhmm } from "UTILS/DateUtils";
import { getUserNameForSelectedLanguage } from "UTILS/Utility";

import ic_delete from "ASSETS/Images/qr_icons/ic_delete.webp";
import ic_error from "ASSETS/Images/ic_error.svg";

import "./Organisations.less";

export default class OrganisationsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      organizationsData: this.props.organizationsData,
      availableModulesDropdown: false,
      moduleId: '',
      showAvailablemoules: false
    };
  }

  componentDidMount() {
    let organizationsData = this.props.organizationsData;
    organizationsData = this.mapImageLabelToAvailAbleModule(organizationsData);
    this.setState({
      organizationsData: organizationsData
    });
  }

  componentDidUpdate(prevProp) {
    let changeFlag = _.isEqual(
      this.props.organizationsData,
      prevProp.organizationsData
    );

    if (!changeFlag) {
      let organizationsData = this.props.organizationsData;

      organizationsData = this.mapImageLabelToAvailAbleModule(
        organizationsData
      );

      this.setState({
        organizationsData: organizationsData
      });
    }
  }

  // shouldComponentUpdate(nextProps, nextState) {
  //   if(!_.isEqual(this.props, nextProps))
  //     return true;
  //   else if(!_.isEqual(this.state, nextState))
  //     return true;
  //   else  
  //     return false
  // }

  mapImageLabelToAvailAbleModule = organizationsData => {
    _.map(organizationsData, (item, index) => {
      let sortedAvailableModules = item.modules ? item.modules : [];

      let updatedAvailableModule = this.props.getAvailableModules(
        sortedAvailableModules
      );

      item.updatedAvailableModules = Object.assign({}, updatedAvailableModule);
    });
    return organizationsData;
  };

  sortByKeys = object => {
    return _.fromPairs(_.map(listOfAvailableModule, key => [key, object[key]]));
  };

  toggle = (id) => {
    this.setState({
      availableModulesDropdown: id,
      showAvailablemoules: !this.state.showAvailablemoules
    });
  }

  availableModulesFormat = (cell, row) => {
    if (!row.updatedAvailableModules) return;
    let updatedAvailableModulesLength = Object.keys(row.updatedAvailableModules).length;
    let messageModule = (updatedAvailableModulesLength === 1) ? getMessage("MODULE") : getMessage("MODULES");
    let availableModule = (updatedAvailableModulesLength < 10) ? ('0' + updatedAvailableModulesLength) : (updatedAvailableModulesLength);
    let dropDownItemClassName = "paddingThings displayFlex-1 alignItemsCenter flexDirectionColumn presentModule noMargin displayFlex px-0"

    return (
      <Container>
        <Dropdown
          direction="down"
          className="dropdown"
          isOpen={this.state.availableModulesDropdown === row.id && this.state.showAvailablemoules}
          toggle={() => { this.toggle(row.id) }}>
          <DropdownToggle className="availableModulesBox" >
            <div className="availableModulesValue">
              {availableModule}
            </div>
            <div className="availableModulesTitle">
              {messageModule}
            </div>
          </DropdownToggle>
          <Row>
            <DropdownMenu className="setDropDownFlexMaragin" >
              {listOfAvailableModule.map((key, index_key) => {
                return row.updatedAvailableModules && row.updatedAvailableModules[key] ?
                  <DropdownItem className="" key={key}>
                    <Col
                      style={{ textAlign: "center" }}
                      className={dropDownItemClassName}
                      key={index_key + 100}
                      lg={12}
                      cellSpacing={12}
                      cellPadding={4}
                    >

                      <div lg={8} className="moduleImage">
                        <img
                          src={row.updatedAvailableModules[key].icon}
                          style={
                            key === modulesAvailableConstant.PDF
                              ? {
                                height: "1.1em",
                                width: "1.1em"
                              }
                              : {
                                height: "1.3em",
                                width: "1.3em"
                              }
                          }
                        />
                      </div>
                      <div lg={8} className="moduleLabel moduleImage" key={index_key + 200}>
                        {row.updatedAvailableModules[key].label === getMessage('CO_BROWSE') ?
                          getMessage(row?.cobrowseSettings?.cobrowseType) : row.updatedAvailableModules[key].label }
                      </div>
                    </Col>
                  </DropdownItem>
                  :
                  null
              })}
            </DropdownMenu>
          </Row>
        </Dropdown>

      </Container>
    )
  }

  deleteFormat = (cell, row) => {
    return (
      <img
        src={ic_delete}
        className="cursorPointer"
        onClick={e => {
          e.stopPropagation();
          this.props.showDeleteConfirmationModal(row.id, row.name);
        }}
      />
    )
  }

  organizationFormat = (cell, row) => {
    return (
      <div className="displayFlex justifyContentFlexCenter">
        <div className="col-3">
          {this.isThresholdValueReached(row) || this.isNoOfSeatsExceeded(row)
            ? <img src={ic_error} alt="Status" className="cursorPointer"
              id="bucketError" data-toggle="tooltip" data-placement="bottom"
              title={this.isThresholdValueReached(row) ? getMessage("THRESHOLD_VALUE_EXCEEDS") : getMessage("NUMBER_OF_AGENTS_EXCEEDS_NUMBER_OF_SEATS")} />
            : null
          }
        </div>
        <div className="col-9 displayFlex">
          <label
            onClick={() =>
              this.props.gotoEditOrganization(row.admins[0].userId, row.id)
            }
            className={"customerName nameEllipsis " + this.getThresholdClassName(row)}
            title={row.name}
          >
            {row.name}
          </label>
        </div>
      </div>
    )
  }

  agentsFormat = (cell, row) => {
    return (
      <div
        className={this.getThresholdClassName(row)}
        data-toggle="tooltip"
        data-placement="top"
        title={row.businessModel === BUSINESS_MODELS.NUMBER_OF_SEATS
          ? getMessage("NO_OF_SEATS")
          : getMessage("MAX_CONCURRENT_CONNECTIONS")}
      >
        {
          {
            [BUSINESS_MODELS.NUMBER_OF_SEATS]: `${getMessage("U")}`,
            [BUSINESS_MODELS.MAX_CONCURRENT_CONNECTIONS]: `${getMessage("C")}`
          }[row.businessModel] ?? getMessage("U") // Default to seats model
        }

      </div>
    )
  }

  sessionFormat = (cell, row) => {
    if (row.lastSessionTime || row.lastSessionTime || row.activeSessions || row.totalSessions)
      return (
        <div>
          <div className={this.getThresholdClassName(row)}
          >
            {row.lastSessionTime ? formatDateByLocale(row.lastSessionTime, this.props.language) : `--`}
          </div>
          <div className={this.getThresholdClassName(row)}
          >
            {row.lastSessionTime ? getTimeInLocaleTimezone(row.lastSessionTime) : `--`}, {row.activeSessions}, {row.totalSessions}
          </div>
        </div>
      )
    else
      return (
        <div className={this.getThresholdClassName(row)}
        >
          --
        </div>
      )
  }

  licenseFormat = (cell, row) => {
    let today = new Date();
    today.setDate(today.getDate() + 30);
    let expiryDate = new Date(row.license_expiry);
    return (
      <div className={expiryDate < today ? "crossesThresholdValue" : this.getThresholdClassName(row)}
      >
        {row.license_expiry ? formatDateByLocale(row.license_expiry, this.props.language) : `--`}
      </div>
    )
  }

  totalMinutesFormat = (cell, row) => {
    return (
      <div className={this.getThresholdClassName(row)}
      >
        {convertMinutesToDDhhmm(row.totalTimeToDate)}
      </div>
    )
  }

  qrCodeStatus = (cell, row) => {
    return (
      <div className={this.getThresholdClassName(row)}
      >
        {row.qrCodeStatus}
      </div>
    )
  }

  delegatedAdminFormat = (cell, row) => {
    return (
      <div className={this.getThresholdClassName(row)}
      >
        {row.admins && row.admins[0].userName ? getUserNameForSelectedLanguage(this.props.language, row.admins[0].userName) : `--`}
      </div>
    )
  }

  sortByLastSessionTime = (a, b, order, field) => {
    const p1 = a[field] ? new Date(a[field]).getTime() : 0;
    const p2 = b[field] ? new Date(b[field]).getTime() : 0;
    if (order == 'desc') {
      return p2 - p1
    }
    return p1 - p2
  }

  sortTotalMinutes = (a, b, order, field) => {
    const p1 = a[field]
    const p2 = b[field]
    if (order == 'desc') {
      return p2 - p1
    }
    return p1 - p2
  }

  isThresholdValueReached = (row) => {
    return (row.businessModel === BUSINESS_MODELS.MAX_CONCURRENT_CONNECTIONS
      && row.concurrentSessionThreshold && row.concurrentSessionThreshold > 0
      && row.activeSessions >= row.concurrentSessionThreshold)
  }
  isNoOfSeatsExceeded = (row) => {
    return (row.businessModel === BUSINESS_MODELS.NUMBER_OF_SEATS
      && row.totalAgents && row.totalAgents > row.seats)
  }

  // if Business Model is Max Concurrent Connections and Threshold value is reached then whole row should be display in red color
  getThresholdClassName = (row) => {
    return this.isThresholdValueReached(row) || this.isNoOfSeatsExceeded(row)
      ? "crossesThresholdValue"
      : ""
  }

  render() {
    let options = {
      defaultSortName: 'lastSessionTime',  // default sort column name
      defaultSortOrder: 'desc'  // default sort order
    };
    return (
      <div className="organisationsListContainer">
        <BootstrapTable
          data={this.state.organizationsData}
          tableHeaderClass="tableHeader"
          tableBodyClass='tableBody'
          containerClass='organisationsList'
          tableContainerClass=''
          headerContainerClass=''
          bodyContainerClass=''
          bordered={false}
          options={options}
        >
          <TableHeaderColumn
            dataField='name'
            width="15%"
            dataSort={true}
            dataFormat={this.organizationFormat}
            dataAlign='center'
            isKey
          >
            <div>
              <div>
                {getMessage("ORGANIZATION")}
              </div>
              <div>
                {getMessage("NAME")}
              </div>
            </div>
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField='totalAgents'
            dataFormat={this.agentsFormat}
            width="12%"
            dataAlign='center'
          >
            <div>
              {getMessage("AGENTS")}
            </div>
            <div className="subHeaderName">
              {getMessage("MODEL")}
            </div>
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField='lastSessionTime'
            dataFormat={this.sessionFormat}
            width="14%"
            dataAlign='center'
            dataSort={true}
            sortFunc={this.sortByLastSessionTime}
          >
            <div>
              {getMessage("SESSION")}
            </div>
            <div className="subHeaderName">
              {getMessage("LAST")}, {getMessage("ACTIVE")}, {getMessage("TOTAL")}
            </div>
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField='license_expiry'
            dataFormat={this.licenseFormat}
            width="14%"
            dataAlign='center'
            dataSort={true}
          >
            <div>
              {getMessage("EXPIRY_DATE")}
            </div>
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField='totalTimeToDate'
            dataFormat={this.totalMinutesFormat}
            width="14%"
            dataAlign='center'
            dataSort={true}
            sortFunc={this.sortTotalMinutes}
          >
            <div>
              {getMessage("TOTAL_USAGE")}
            </div>
            <div>
              {getMessage("TO_DATE")}
            </div>
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField='qrCodeStatus'
            dataFormat={this.qrCodeStatus}
            width="10%"
            dataAlign='center'
          >
            <div>
              {getMessage("QR_CODES")}
            </div>
            <div className="subHeaderName">
              {getMessage("ACTIVE")}/{getMessage("ALLOCATED")}
            </div>
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField='admins'
            dataFormat={this.delegatedAdminFormat}
            width="15%"
            dataAlign='center'
          >
            <div>
              {getMessage("DELEGATED")}
            </div>
            <div>
              {getMessage("ROLE_ADMIN")}
            </div>
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField='updatedAvailableModules'
            width="10%"
            dataFormat={this.availableModulesFormat}
            dataAlign='center'
          >
            <div>
              {getMessage("AVAILABLE")}
            </div>
            <div>
              {getMessage("MODULES")}
            </div>
          </TableHeaderColumn>
          <TableHeaderColumn
            width="10%"
            dataFormat={this.deleteFormat}
            dataAlign="center"
          >
            {getMessage("DELETE")}
          </TableHeaderColumn>
        </BootstrapTable>

      </div>
    );
  }
}
